import './EmailLog.css'
import { LuReply, LuForward, LuSendHorizontal } from "react-icons/lu";
import { useState } from 'react';
import CompleteLogModal from "../modals/CompleteLogModal";
function formatTimestamp(value) {
    if (!value) {
        return "";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleString([], {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
}

function previewText(value, maxLength = 100) {
    const normalized = String(value || "").replace(/\s+/g, " ").trim();
    if (!normalized) {
        return "(no preview)";
    }
    return normalized.length > maxLength ? `${normalized.slice(0, maxLength)}...` : normalized;
}

function EmailLog({
    emailConversations = [],
    emailConversationsLoading = false,
    emailConversationsError = "",
    emailMessages = [],
    emailMessagesLoading = false,
    emailMessagesError = "",
    emailPage = 1,
    emailTotalPages = 1,
    emailSearchQuery = "",
    selectedEmailThreadId = "",
    selectedEmailConversation = null,
    emailComposeMode = false,
    emailComposeAction = { type: "new", messageId: "" },
    emailForm = { to: "", subject: "", body: "" },
    emailSending = false,
    emailFeedback = "",
    emailGraphConnected = false,
    onEmailSearchChange,
    onEmailPrevPage,
    onEmailNextPage,
    onEmailSelectConversation,
    onEmailComposeChange,
    onEmailStartCompose,
    onEmailCancelCompose,
    onEmailSend,
    onEmailReply,
    onEmailReplyAll,
    onEmailForward,
    onEmailCompleteLog
}) {
    const composeType = emailComposeAction?.type || "new";
    const needsRecipient = composeType === "new" || composeType === "forward";
    const needsSubject = composeType === "new" || composeType === "forward";
    const sendLabel = composeType === "reply"
        ? "Send Reply"
        : composeType === "replyAll"
            ? "Send Reply All"
            : composeType === "forward"
                ? "Send Forward"
                : "Send";
    
    const [showCompleteLogModal, setShowCompleteLogModal] = useState(false);
    return (
        <div className="contact-email-log__container">
            <header className="contact-email-log__header">
                <h3>Email Log</h3>
                <button
                    type="button"
                    className="contact-email-log__compose"
                    onClick={() => onEmailStartCompose?.()}
                >
                    Compose +
                </button>

                <button type="button" className="contact-email-log__compose" onClick={() => setShowCompleteLogModal(true)}>
                    Send
                </button>
            </header>

            <div className="contact-email-log__body">
                <aside className="contact-email-log__sidebar">
                    <div className="contact-email-log__folder-row">
                        <span>Inbox</span>
                        <span className="contact-email-log__count">{emailConversations.length}</span>
                    </div>

                    <input
                        type="search"
                        className="contact-email-log__search"
                        placeholder="Search"
                        value={emailSearchQuery}
                        onChange={(event) => onEmailSearchChange?.(event.target.value)}
                    />

                    <div className="contact-email-log__pager">
                        <button type="button" onClick={() => onEmailPrevPage?.()} disabled={emailConversationsLoading || emailPage <= 1}>
                            Prev
                        </button>
                        <span>Page {Math.max(emailPage, 1)} of {Math.max(emailTotalPages, 1)}</span>
                        <button
                            type="button"
                            onClick={() => onEmailNextPage?.()}
                            disabled={emailConversationsLoading || emailPage >= Math.max(emailTotalPages, 1)}
                        >
                            Next
                        </button>

                        
                    </div>

                    <div className="contact-email-log__list">
                        {emailConversationsLoading ? (
                            <p className="contact-email-log__empty">Loading conversations...</p>
                        ) : emailConversationsError ? (
                            <p className="contact-email-log__empty">{emailConversationsError}</p>
                        ) : emailConversations.length === 0 ? (
                            <p className="contact-email-log__empty">No conversations found.</p>
                        ) : (
                            emailConversations.map((conversation) => {
                                const key = String(conversation?.thread_id || conversation?.id || "");
                                const isSelected = key === String(selectedEmailThreadId || "");

                                return (
                                    <button
                                        key={key}
                                        type="button"
                                        className={`contact-email-log__item${isSelected ? " is-active" : ""}`}
                                        onClick={() => onEmailSelectConversation?.(key)}
                                    >
                                        <div className="contact-email-log__item-subject">{conversation?.subject || "No subject"}</div>
                                        <div className="contact-email-log__item-contact">{conversation?.contact_name || "Unknown contact"}</div>
                                        <div className="contact-email-log__item-meta">
                                            {conversation?.message_count || 0} msg{Number(conversation?.message_count || 0) === 1 ? "" : "s"}
                                            {" · "}
                                            {formatTimestamp(conversation?.updated_at)}
                                        </div>
                                    </button>
                                );
                            })
                        )}
                    </div>
                </aside>

                <section className="contact-email-log__thread">
                    <div className="contact-email-log__thread-title">Message Thread</div>

                    {emailComposeMode ? (
                        <div className="contact-email-log__compose-panel">
                            {!emailGraphConnected ? (
                                <p className="contact-email-log__feedback">Microsoft 365 is not connected. Connect it from the Conversations page first.</p>
                            ) : null}
                            {emailFeedback ? <p className="contact-email-log__feedback">{emailFeedback}</p> : null}

                            {needsRecipient ? (
                                <input
                                    type="email"
                                    placeholder="To"
                                    value={emailForm.to || ""}
                                    onChange={(event) => onEmailComposeChange?.("to", event.target.value)}
                                    disabled={emailSending}
                                />
                            ) : null}
                            {needsSubject ? (
                                <input
                                    type="text"
                                    placeholder="Subject"
                                    value={emailForm.subject || ""}
                                    onChange={(event) => onEmailComposeChange?.("subject", event.target.value)}
                                    disabled={emailSending}
                                    className="contact-email-log__compose-panel-subject"
                                />
                            ) : null}
                            <textarea
                                rows={12}
                                placeholder={composeType === "forward" ? "Add a note to the forwarded email" : "Message"}
                                value={emailForm.body || ""}
                                onChange={(event) => onEmailComposeChange?.("body", event.target.value)}
                                disabled={emailSending}
                            />

                            <div className="contact-email-log__compose-actions">
                                <button type="button" onClick={() => onEmailSend?.()} disabled={emailSending}>
                                    {emailSending ? "Sending..." : sendLabel}
                                    <LuSendHorizontal />
                                </button>
                                <button className="contact-email-log__compose-actions-cancel" type="button" onClick={() => onEmailCancelCompose?.()} disabled={emailSending}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="contact-email-log__messages">
                            {!selectedEmailConversation ? (
                                <p className="contact-email-log__empty">Select a conversation to view messages.</p>
                            ) : emailMessagesLoading ? (
                                <p className="contact-email-log__empty">Loading messages...</p>
                            ) : emailMessagesError ? (
                                <p className="contact-email-log__empty">{emailMessagesError}</p>
                            ) : emailMessages.length === 0 ? (
                                <p className="contact-email-log__empty">No messages in this conversation.</p>
                            ) : (
                                emailMessages.map((message) => (
                                    <article key={String(message?.id)} className="contact-email-log__message-item">
                                        <div className="contact-email-log__message-meta">
                                            <span>{String(message?.direction || "message").toUpperCase()}</span>
                                            <span>{formatTimestamp(message?.sent_at)}</span>
                                        </div>
                                        <p className="contact-email-log__message-subject">{message?.subject || "No subject"}</p>
                                        <p className="contact-email-log__message-body">{previewText(message?.body_text, 450)}</p>
                                        <div className="contact-email-log__message-actions">
                                            <button type="button" onClick={() => onEmailReply?.(message)}>
                                                <LuReply/>
                                                Reply
                                            </button>
                                            <button type="button" onClick={() => onEmailReplyAll?.(message)}>
                                                <LuReply/>
                                                Reply All
                                            </button>
                                            <button type="button" onClick={() => onEmailForward?.(message)}>
                                                Forward
                                                <LuForward/>
                                            </button>
                                        </div>
                                    </article>
                                ))
                            )}
                        </div>
                    )}
                </section>
            </div>

            <CompleteLogModal isOpen={showCompleteLogModal} onClose={() => setShowCompleteLogModal(false)} />
        </div>
    );
}

export default EmailLog;